import React from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import StoryMetaData from "../../molecules/StoryMetaData";

import { staticTexts } from "../../utils/Translate";

import "./latestStories.m.css";

const LatestStories = ({ story, stories, lang }) => {
  const relText =
    story && story["story-template"] === "photo"
      ? staticTexts(lang).morePhotoStories
      : staticTexts(lang).relatedStories;
  return (
    <div styleName="latest-stories">
      <h2 styleName="related-story-heading">{relText}</h2>
      <div styleName="story-container">
        {stories.map((story, index) => {
          return (
            <div key={index}>
              <Link aria-label={story.headline} href={story.url}>
                <CardImage
                  story={story}
                  defaultWidth={300}
                  aspectRatio={[3, 2]}
                  imageType="image3x2"
                  widths={global.deviceWidth < 876 ? [120] : [300]}
                  showAlternateImage={true}
                />
              </Link>

              <div styleName="story-title">
                <NewsHeadline story={story} />
              </div>
              <StoryMetaData story={story} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

LatestStories.propTypes = {
  stories: array.isRequired,
  lang: string,
  story: object,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(LatestStories);
